import { gql } from '@apollo/client'

const GET_CHALLENGES = gql`
  query Challenges($partnerId: String, $v2Flag: Boolean) {
    challenges(partnerId: $partnerId, v2Flag: $v2Flag) {
      id
      title
      description
      startTime
      endTime
    }
  }
`

const GET_CHALLENGE = gql`
  query Challenge($challengeId: String!, $clientDate: DateTime, $v2Flag: Boolean) {
    challenge(challengeId: $challengeId, clientDate: $clientDate, v2Flag: $v2Flag) {
      id
      title
      description
      startTime
      endTime
      employeeCount
      participantCount
      completedCount
      classesCompletedCount
      totalMinutes
      top5Classes {
        rideTitle
        classesTakenCount
      }
      top5Instructors {
        firstName
        lastName
        rideCount
      }
      daysElapsed
      daysTotal
    }
  }
`

const GET_FINISHERS = gql`
  query Finishers($challengeId: String!, $partnerId: String) {
    finishers(challengeId: $challengeId, partnerId: $partnerId) {
      firstName
      lastName
      email
      companyEmail
      achievedTier
    }
  }
`

const GET_PARTICIPANTS = gql`
  query Participants($challengeId: String!, $partnerId: String) {
    participants(challengeId: $challengeId, partnerId: $partnerId) {
      firstName
      lastName
      email
      companyEmail
      achievedTier
    }
  }
`

export { GET_CHALLENGES, GET_CHALLENGE, GET_FINISHERS, GET_PARTICIPANTS }
